export default __webpack_public_path__ + "static/media/haha.232df769.gif";